import { KameleoonGoalData } from '@/hooks/kameleoon/kameleoonGoals';
import { useTrackConversion } from '@/hooks/kameleoon/useTrackConversion';

export const useTrackForYouLoggedInButtonClicked = () =>
    useTrackConversion({ goal: KameleoonGoalData.ForYouLoggedInButtonClicked });
